<template>
  <v-container class="pa-0 mb-4">
    <v-layout row wrap>
      <v-flex xs12>
        <Settings @saveTest="saveTest" />
      </v-flex>
    </v-layout>
    <AdView id="166" />
    <v-layout row wrap>
      <v-flex v-for="item in testSetupActiveItems" xs12 sm6 md4 :key="item.id">
        <FC v-if="item.id == 'fc'" />
        <PH v-else-if="item.id == 'ph'" />
        <TA v-else-if="item.id == 'ta'" />
        <CH v-else-if="item.id == 'ch'" />
        <CYA v-else-if="item.id == 'cya'" />
        <Borate v-else-if="item.id == 'borate'" />
        <Salt v-else-if="item.id == 'salt'" />
        <SUG v-else-if="item.id == 'sug'" />
        <CSI v-else-if="item.id == 'csi'" />
        <CustomField
          v-else-if="item.id.startsWith('custom_')"
          :fieldID="item.id"
        />
      </v-flex>
    </v-layout>
    <AdView id="165" />
    <PCModal />
    <v-snackbar v-model="snackbar.show" :bottom="true" :right="true">
      {{ snackbar.message }}
      <v-btn color="red" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import firebase from "@/firebase";

import AdView from "@/components/AdView";
import PCModal from "@/components/PCModal";
import Borate from "@/components/calculator/Borate";
import CH from "@/components/calculator/CH";
import CustomField from "@/components/calculator/CustomField";
import CYA from "@/components/calculator/CYA";
import CSI from "@/components/calculator/CSI";
import FC from "@/components/calculator/FC";
import PH from "@/components/calculator/PH";
import Salt from "@/components/calculator/Salt";
import Settings from "@/components/calculator/Settings";
import SUG from "@/components/calculator/SUG";
import TA from "@/components/calculator/TA";

const defaultDefaultTestSetup = [
  "fc",
  "ph",
  "ta",
  "ch",
  "cya",
  "borate",
  "salt",
  "sug",
  "csi",
].map((id) => ({ id, active: true }));

export default {
  components: {
    AdView,
    Borate,
    CH,
    CustomField,
    CYA,
    CSI,
    FC,
    PCModal,
    PH,
    Salt,
    Settings,
    SUG,
    TA,
  },
  data() {
    return {
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      borate: "borate/getBorate",
      ch: "ch/getCH",
      cya: "cya/getCYA",
      fc: "fc/getFC",
      ph: "ph/getPH",
      salt: "salt/getSalt",
      settings: "settings/getSettings",
      ta: "ta/getTA",
      user: "user/getUser",
    }),
    ...mapState({
      customFieldStates: "customFieldStates",
      fields: "fields",
    }),
    testsRef() {
      return firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("tests");
    },
    testSetupActiveItems() {
      const setting =
        this.settings.pool.testSetup ||
        this.settings.defaultTestSetup ||
        defaultDefaultTestSetup;

      return setting.filter((item) => item.active);
    },
  },
  methods: {
    ...mapActions({
      initFields: "fields/initFields",
    }),
    async saveTest() {
      try {
        if (typeof this.settings.pool.name !== "undefined") {
          const customFieldValues = {};
          const customFieldGoals = {};

          this.testSetupActiveItems.forEach((item) => {
            if (item.id.startsWith("custom_")) {
              const id = item.id.substring(7);
              for (let i = 0; i < this.fields.length; i++) {
                const field = this.fields[i];
                if (field.id === id) {
                  if (id in this.customFieldStates) {
                    const state = this.customFieldStates[id];
                    customFieldValues[id] = state.tested;
                    if (typeof state.goal !== "undefined")
                      customFieldGoals[id] = state.goal;
                  }
                  break;
                }
              }
            }
          });

          await this.testsRef.add({
            poolID: this.settings.pool.id,
            pool: this.settings.pool.name,
            timestamp: new Date().toISOString(),
            fc: this.fc.tested,
            ph: this.ph.tested,
            ta: this.ta.tested,
            ch: this.ch.tested,
            cya: this.cya.tested,
            borate: this.borate.tested,
            salt: this.salt.tested,
            customFieldValues,
            goals: {
              customFieldValues: customFieldGoals,
            },
          });
          this.snackbar.show = true;
          this.snackbar.message = "The test was saved successfully";
        } else {
          this.snackbar.show = true;
          this.snackbar.message =
            "You need to set up a pool first. Please go to Settings => Pools to set up a pool.";
        }
      } catch (err) {
        this.snackbar.show = true;
        this.snackbar.message = err.message;
      }
    },
  },
  mounted() {
    this.initFields();
  },
};
</script>

<style lang="scss">
.premium {
  border-radius: 0;
}
.adsbygoogle {
  height: 140px !important;
}
</style>
